import { ChangeEvent } from 'react';
import { Plus, Search } from 'lucide-react';
import { ShipmentsToolbarProps } from './types';

const ShipmentsToolbar = (props: ShipmentsToolbarProps) => {
  const {
    onCreateShipment,
    onSearchChange,
    searchValue
  } = props;

  const onChangeSearchInput = (event: ChangeEvent<HTMLInputElement>): void => {
    onSearchChange(event.target.value);
  };

  return (
    <div className="flex flex-col gap-2 min-[769px]:flex-row">
      <div className="relative w-full min-[769px]:flex-1">
        <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <input
          className="w-full px-3 py-2 pl-9 font-sans text-sm text-foreground rounded-xl border border-border bg-card placeholder:text-muted-foreground transition-[border-color,box-shadow,background-color] focus:border-[hsl(var(--border-focus))] focus:ring-1 focus:ring-[hsl(var(--border-focus))] focus:outline-none"
          onChange={onChangeSearchInput}
          placeholder="Поиск..."
          type="text"
          value={searchValue}
        />
      </div>
      <button
        className="flex w-full shrink-0 items-center justify-center gap-1.5 px-3 py-2 min-[769px]:w-[calc((100%_-_2rem)/5)] font-sans text-sm font-medium leading-5 whitespace-nowrap text-accent-foreground rounded-xl bg-accent transition-colors hover:bg-accent/90"
        onClick={onCreateShipment}
        type="button"
      >
        <Plus className="size-4" />
        Новая поставка
      </button>
    </div>
  );
};

export default ShipmentsToolbar;